<template>
  <el-card shadow="never" class="card">
    <div class="toolbar">
      <el-form :inline="true" class="search-form" @submit.native.prevent>
        <el-form-item label="员工编号">
          <el-input
            v-model="query.employee_no"
            placeholder="请输入推粉号编号"
            clearable
            style="width: 220px;"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="query.status"
            placeholder="全部"
            clearable
            style="width: 160px;"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="list"
      style="width: 100%; border: 1px solid #dfe6ec;"
      :header-cell-style="{ backgroundColor: '#f5f7fb', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column prop="job_no" label="任务编号" min-width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.job_no || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="推粉号编号" min-width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.employee_no || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="推粉号信息" min-width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag type="success">
            {{ scope.row.corp_user_name || '-' }}@{{ scope.row.corp_name || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="推粉号公司" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.corp_name || '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="接粉号编号" min-width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.accept_employee_no || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="接粉号信息" min-width="240" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag type="warning">
            {{ scope.row.accept_employee_name || '-' }}@{{ scope.row.accept_employee_corp_name || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="接粉号公司" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.accept_employee_corp_name || '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="粉丝类型" width="100">
        <template slot-scope="scope">
          {{ scope.row.fans_type_text || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="粉丝集合" min-width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.friend_names && scope.row.friend_names.length">
            <div
              class="ellipsis-inline ellipsis-inline--clickable"
              :title="'点击查看全部（共 ' + scope.row.friend_names.length + ' 人）'"
              @click="openFriendNamesDialog(scope.row.friend_names)"
            >
              {{ formatFriendNames(scope.row.friend_names) }}
            </div>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          {{ scope.row.status_text || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="推送数量" width="90">
        <template slot-scope="scope">
          {{ scope.row.actually_card_count != null ? scope.row.actually_card_count : '无' }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.remark || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170">
        <template slot-scope="scope">
          {{ scope.row.created_at_text || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="170">
        <template slot-scope="scope">
          {{ scope.row.updated_at_text || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="small"
            :loading="repushingJobNo === scope.row.job_no"
            @click="handleRepush(scope.row)"
          >
            重推
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="query.page_size"
        :current-page="query.page"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>

    <el-dialog
      :title="'粉丝集合（共 ' + friendNamesDialogList.length + ' 人）'"
      :visible.sync="friendNamesDialogVisible"
      width="560px"
      append-to-body
    >
      <div class="friend-names-tags">
        <el-tag
          v-for="(name, idx) in friendNamesDialogList"
          :key="idx"
          size="small"
        >
          {{ name }}
        </el-tag>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="friendNamesDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { businessCardRecordList, businessCardRecordRepush } from '@/api/index'

export default {
  name: 'BusinessCardSendRecord',
  data() {
    return {
      loading: false,
      repushingJobNo: null,
      friendNamesDialogVisible: false,
      friendNamesDialogList: [],
      list: [],
      total: 0,
      query: {
        page: 1,
        page_size: 10,
        employee_no: '',
        status: undefined
      },
      /** 与后端 status 枚举对齐时可修改此项 */
      statusOptions: [
        { value: 1, label: '待执行' },
        { value: 2, label: '执行中' },
        { value: 3, label: '已完成' },
        { value: 4, label: '失败' }
      ]
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    buildParams() {
      const params = {
        page: this.query.page,
        page_size: this.query.page_size
      }
      const no = (this.query.employee_no || '').trim()
      if (no) params.employee_no = no
      if (this.query.status !== '' && this.query.status !== null && this.query.status !== undefined) {
        params.status = this.query.status
      }
      return params
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await businessCardRecordList(this.buildParams())
        const payload = res.data || {}
        this.list = payload.list || payload.data || []
        this.total = payload.total != null ? payload.total : (payload.count || 0)
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.query.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.query.page_size = size
      this.query.page = 1
      this.fetchList()
    },
    handleReset() {
      this.query = {
        page: 1,
        page_size: 10,
        employee_no: '',
        status: undefined
      }
      this.fetchList()
    },
    formatFriendNames(names) {
      if (!names || !names.length) return '-'
      const joined = names.join('、')
      return joined.length > 48 ? `${joined.slice(0, 48)}…` : joined
    },
    openFriendNamesDialog(names) {
      this.friendNamesDialogList = Array.isArray(names) ? names.slice() : []
      this.friendNamesDialogVisible = true
    },
    async handleRepush(row) {
      const jobNo = row.job_no
      if (!jobNo) {
        this.$message.warning('缺少任务编号，无法重推')
        return
      }

      this.repushingJobNo = jobNo
      try {
        await businessCardRecordRepush({ job_no: jobNo })
        this.$message.success('已提交重推')
        this.fetchList()
      } finally {
        this.repushingJobNo = null
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin: 22px;
}
.toolbar {
  margin-bottom: 16px;
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.pager {
  margin-top: 20px;
  text-align: right;
}
.ellipsis-inline {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.ellipsis-inline--clickable {
  cursor: pointer;
  color: #2468f2;
  text-align: left;
  transition: color 0.15s ease;
}

.ellipsis-inline--clickable:hover {
  color: #1a56d8;
  text-decoration: underline;
}

.friend-names-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
  align-items: flex-start;
  max-height: 360px;
  overflow-y: auto;
  padding: 4px 0;
  line-height: 1.6;
}

.repush-action.el-button--text {
  padding: 6px 12px !important;
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #2468f2 !important;
  border-radius: 6px;
  transition: color 0.18s ease, background-color 0.18s ease;
}

.repush-action.el-button--text:hover,
.repush-action.el-button--text:focus {
  color: #1a56d8 !important;
  background-color: rgba(36, 104, 242, 0.09) !important;
}

.repush-action.el-button--text:active {
  color: #154cbd !important;
  background-color: rgba(36, 104, 242, 0.14) !important;
}

.repush-action.el-button--text.is-loading {
  color: #2468f2 !important;
  opacity: 0.85;
}

.repush-action >>> .el-icon-refresh-right {
  font-size: 14px;
  margin-right: 4px;
  vertical-align: -1px;
}
</style>
